/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var fetch = MoyaContainer.get('core.fetch');
    var MoyaOverlayClass = MoyaContainer.get('core.overlay').OverlayClass;
    var OverlayStyle;
    (function (OverlayStyle) {
        OverlayStyle["LIGHT"] = "light";
    })(OverlayStyle || (OverlayStyle = {}));
    MoyaComponents.register('mailchimp.subscribe-box', function (el) {
        var subscribeBox = new SubscribeBox(el);
        subscribeBox.run();
    });
    var SubscribeBox = /** @class */ (function () {
        function SubscribeBox(elm) {
            this.formElement = elm;
            this.responseDiv = document.querySelector('.submit_messaage');
        }
        SubscribeBox.prototype.run = function () {
            this.bindSubmitForm();
        };
        SubscribeBox.prototype.bindSubmitForm = function () {
            var _this = this;
            util.delegate(this.formElement, 'submit', 'form', function (e) {
                _this.responseDiv.classList.remove('success');
                _this.responseDiv.classList.remove('error');
                e.preventDefault();
                var overlay = new MoyaOverlayClass(_this.formElement, { style: OverlayStyle.LIGHT });
                overlay.show("spinner" /* SPINNER */);
                fetch.fetchJson(_this.formElement.action, 'POST', new FormData(_this.formElement))
                    .then(function (res) {
                    if (res.success === true) {
                        _this.responseDiv.classList.add('success');
                    }
                    else {
                        _this.responseDiv.classList.add('error');
                    }
                    _this.responseDiv.innerHTML = '<div>' + res.message + '</div>';
                    overlay.hide();
                });
            }, true);
        };
        return SubscribeBox;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
